import React, { useEffect, useState } from 'react';
import { Container, Table, Spinner, Button, Modal } from 'react-bootstrap';
import { get } from '../utils/api';
import { CURRENCY_SYMBOL } from '../config';

const MyPayments = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchPayments = async () => {
      try {
        const { data } = await get('/payments/my');
        setPayments(data);
      } catch (error) {
      }
      setLoading(false);
    };

    fetchPayments();
  }, []);

  const handleShowModal = async (payment) => {
    setSelectedPayment(payment);
    setShowModal(true);
    try {
      const { data } = await get(`/payments/${payment.payment_id}`);
      setSelectedPayment(data);
    } catch (error) {
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedPayment(null);
  };

  const formatDate = (dateString) => {
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-GB', options);
  };

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" />
      </Container>
    );
  }

  return (
    <Container>
      <h2 className="my-4">My Payments</h2>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Payment ID</th>
            <th>Order ID</th>
            <th>Amount</th>
            <th>Payment Method</th>
            <th>Status</th>
            <th>Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {payments.length > 0 ? (
            payments.map((payment) => (
              <tr key={payment.payment_id}>
                <td>{payment.payment_id}</td>
                <td>{payment.order_id}</td>
                <td>{CURRENCY_SYMBOL}{payment.amount}</td>
                <td>{payment.payment_method}</td>
                <td>{payment.payment_status.toUpperCase()}</td>
                <td>{formatDate(payment.created_at)}</td>
                <td>
                  <Button variant="info" size="sm" onClick={() => handleShowModal(payment)}>
                    View Details
                  </Button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className="text-center">No payments found.</td>
            </tr>
          )}
        </tbody>
      </Table>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Payment Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedPayment ? (
            <div>
              <p><strong>Payment ID:</strong> {selectedPayment.payment_id}</p>
              <p><strong>Order ID:</strong> {selectedPayment.order_id}</p>
              <p><strong>Amount:</strong> {CURRENCY_SYMBOL}{selectedPayment.amount}</p>
              <p><strong>Payment Method:</strong> {selectedPayment.payment_method}</p>
              <p><strong>Status:</strong> {selectedPayment.payment_status.toUpperCase()}</p>
              <p><strong>Date:</strong> {formatDate(selectedPayment.created_at)}</p>
            </div>
          ) : (
            <Spinner animation="border" />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default MyPayments;
